import React from 'react';
import BaseComponent from '../../components/system/base';
import Popup from '../../components/popup';
import FireBaseContext from '../../context/fireBaseContext';
import WinPopup from './winPopup';
import LosePopup from './losePopup';
import SlotMachine from './slotShell';
import Auth from '../auth/auth'
import Probability from 'probability-node';
import PacmanLoader from "react-spinners/PacmanLoader";
import PubSub from 'pubsub-js';

const $ = window;

class WinPrize extends BaseComponent {
  static contextType = FireBaseContext;

  constructor(props, context) {
    super(props, context);
    this.state = this.defaultUserState();
  }

  defaultUserState() {
    return {
      user: {
        info: {
        }
      },
      showSlot: false,
      showModal: false,
      popUpDone: false,
      youWon: false,
      productNameWon: "",
    }
  }

  // calculate winnings. Trying to obfuscate things so people dont hack the JS to win
  c = (data) => {
    var winnings = {};
    var youWon = false;
    var productIdWon = "";
    var productCategory = "";
    var productNameWon = "";
    var terms = "";
    var expireDays = 0;
    if (this.globs.length(data.Products) > 0) {
      this.globs.forEach(data.Products, (product) => {
        winnings[product.Slug] = 0;
        if (product.Odds > 0) {
          var probabilitilized = new Probability({
              p: 1/product.Odds,
              f: () => {
                winnings[product.Slug]++;
              }
          });
          probabilitilized();
        }
      });
      if (this.globs.length(winnings) > 0) {
        var currentProductWonPriority = 0;
        this.globs.forEach(data.Products, (product) => {
          this.globs.forEach(winnings, (wins, key) => {
            if (key === product.Slug && wins > 0 && product.Priority >= currentProductWonPriority) {
              youWon = true;
              currentProductWonPriority = product.Priority;
              productIdWon = product.Slug;
              productCategory = product.Category;
              expireDays = product.ExpireDays;
              if (this.lang == "jp") {
                productNameWon = product.TitleJP;
                terms = product.TermsJP;
              } else {
                productNameWon = product.Title;
                terms = product.Terms;
              }
            }
          });
        });
        let userDoc = this.context.firebase.firestore().collection("users").doc($.user.uid);
        userDoc.get().then((doc) => {
          let currentRow = doc.data();
          let customerId = this.globs.GetVar("c");
          let update = {UserId: $.user.uid};
          if (currentRow.QuarterlyRaffle === undefined) {
            update.QuarterlyRaffle = 1;
          } else {
            update.QuarterlyRaffle = currentRow.QuarterlyRaffle + 1;
          }

          if (currentRow.PunchCards === undefined) {
            update.PunchCards = {};
          } else {
            update.PunchCards = currentRow.PunchCards;
          }
          if (!youWon) {
            if (!update.PunchCards.hasOwnProperty(customerId)) {
              update.PunchCards[customerId] = 1;
            } else {
              update.PunchCards[customerId] = currentRow.PunchCards[customerId] + 1;
            }
          }

          if (currentRow.ProductWinnings === undefined) {
            update.ProductWinnings = {};
          } else {
            update.ProductWinnings = currentRow.ProductWinnings;
          }
          if (!update.ProductWinnings.hasOwnProperty(customerId)) {
            update.ProductWinnings[customerId] = [];
          }
          update.ProductWinnings[customerId].push({DaysLeft: expireDays, ProductId: productIdWon, Category: productCategory, ProductName: productNameWon, Terms: terms});
          $.firebaseUser = update;
          userDoc.set(update);
        }).catch((e) => {
          alert("An error occurred to fetch information " + e.message);
        });

        this.setState((s) => {
          s.showSlot = true;
          s.youWon = youWon;
          s.punchCard = {};
          s.productIdWon = productIdWon;
          s.punchCard = data.PunchCardProducts;
          s.businessName = data.Name;
          s.businessImage = data.BusinessImage;
          s.terms = terms;
          s.expireDays = expireDays;
          s.productNameWon = productNameWon;
          s.productCategory = productCategory;
          return s;
        })
      } else {
        alert("Probability Error");
      }
    } else {
      alert("No customer products");
    }
  }

  componentDidMount() {
    this.slotDoneToken = PubSub.subscribe('slot-done', (msg, data) => {
      this.setState({showModal: true, showSlot: false})
    });

    this.redeemDone = PubSub.subscribe('redeem-done', (msg, data) => {
      this.setState({popUpDone: true, showModal: false, showSlot: false});
    });

    this.db = this.context.firebase.firestore();
    this.unregisterAuthObserver = this.context.firebase.auth().onAuthStateChanged((user) => {
      if (user !== undefined && user !== null) {
        this.setState((s) => {
          s.user.isSignedIn = !!user;
          s.user.info = user;
          return s;
        }, () => {
          window.setTimeout(() => {
            this.setState({init: false})
            let customerId = this.globs.GetVar("c");
            if (customerId) {
              this.db.collection("customers").doc(customerId).get().then((doc) => {
                this.c(doc.data());
              }).catch((e) => {
                alert("An error occurred to submit information " + e.message);
              });
            } else {
              alert("An error occurred, c error");
            }
          }, 1500);
        });
      }
    });
  }

  componentWillUnmount() {
    PubSub.unsubscribe(this.slotDoneToken);
    PubSub.unsubscribe(this.redeemDone);
    this.unregisterAuthObserver();
  }

  render() {
    let page = null;
    if (this.state.user.isSignedIn && !this.state.user.info.isAnonymous) {
      page = <span>
        {!this.state.showSlot && this.state.showModal && <Popup open={this.state.showModal} closeOnOverlayClick={true} onClickOverlay={() => {
            this.setState({popUpDone: true})
          }}>
          {this.state.youWon ?
            <WinPopup productNameWon={this.state.productNameWon} businessImage={this.state.businessImage} expireDays={this.state.expireDays} category={this.state.productCategory} productIdWon={this.state.productIdWon} redeeNow={false}  businessName={this.state.businessName} terms={this.state.terms} />:
            <LosePopup punchCard={this.state.punchCard}/>
          }
        </Popup>}
        {this.state.showSlot && !this.state.showModal && <SlotMachine/>}
        {!this.state.showSlot && !this.state.showModal && !this.state.popUpDone ? <div className="sweet-loading" style={{marginLeft: "35%", marginTop: "50%"}}>
          <PacmanLoader
            size={58}
            color={"#1691CF"}
            loading={!this.state.showSlot}
          />
        </div>: <React.Fragment>
          {this.state.popUpDone && <div>
            This is shown after popup win
          </div>}
        </React.Fragment>}
      </span>
    } else {
      page = <Auth/>
    }

    return page;
  }
}

export default WinPrize;




// WEBPACK FOOTER //
// ./src/content/winPrize/index.js